import { useAuth } from "../../../../../context";
import { useMutation, useQuery } from "react-query";
import {
  SupplierQuestionnaireWasteGeneratedInOperations
} from "../../../../../api/supplier-questionnaire/tabs/categories";

export const supplierQuestionnaireWasteGeneratedInOperationsKeys = {
  items: () => ["supplierQuestionnaireWasteGeneratedInOperationsItems"],
  preview: () => ["supplierQuestionnaireWasteGeneratedInOperationsPreviewData"]
};

export function useGetSupplierQuestionnaireWasteGeneratedInOperationsItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierQuestionnaireWasteGeneratedInOperationsKeys.items(),
      params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(SupplierQuestionnaireWasteGeneratedInOperations.getWasteGeneratedInOperationsItems, params), config);
}

export function useAddSupplierQuestionnaireWasteGeneratedInOperationsItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(SupplierQuestionnaireWasteGeneratedInOperations.addWasteGeneratedInOperationsItems, {
      questionnaireId,
      data
    }), config);
}

export function useUpdateSupplierQuestionnaireWasteGeneratedInOperationsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(SupplierQuestionnaireWasteGeneratedInOperations.updateWasteGeneratedInOperationsItem, {
      questionnaireId,
      recordId,
      data
    }), config);
}

export function useDeleteSupplierQuestionnaireWasteGeneratedInOperationsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(SupplierQuestionnaireWasteGeneratedInOperations.deleteWasteGeneratedInOperationsItem, {
      questionnaireId,
      recordId
    }), config);
}

export function useImportSupplierQuestionnaireWasteGeneratedInOperationsItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(SupplierQuestionnaireWasteGeneratedInOperations.importWasteGeneratedInOperationsItems, {
      questionnaireId,
      data
    }), config);
}

export function useGetWasteGeneratedInOperationsPreviewData(previewId, params, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierQuestionnaireWasteGeneratedInOperationsKeys.preview(),
      previewId, params.page, params.size],
    () => callApi(SupplierQuestionnaireWasteGeneratedInOperations.getWasteGeneratedInOperationsPreviewData,
      { previewId, params }), config);
}